// Source of truth: InputGUI.py :: stability_options, prosperity_options
export const PROVINCE_CHAOS_LEVELS = ['High', 'Medium', 'Low'];
export const PROVINCE_STABILITIES = [
  '1 - Peaceful & Secure – crime is rare, people sleep easy',
  '2 - Quiet & Orderly – minor issues handled quickly',
  '3 - Mostly Stable – occasional trouble, nothing serious',
  '4 - Uneasy Calm – rumors, petty crime, growing tensions',
  '5 - Strained – protests, bandits, shortages, distrust rising',
  '6 - Restless – clashes, sabotage, faction pressure increasing',
  '7 - Dangerous – raids, corruption, militia conflict common',
  '8 - Volatile – open violence, border threats, frequent attacks',
  '9 - Near Collapse – rebellion, invasion, famine, law breaking down',
  '10 - War Zone – active conflict, survival replaces law',
];

export const PROVINCE_PROSPERITIES = [
  '1 - Desperate – famine, disease, displacement, begging everywhere',
  '2 - Starving – failing farms, broken roads, constant scarcity',
  '3 - Poor – barely surviving, low trade, fragile economy',
  '4 - Struggling – working hard, little reward, frequent shortages',
  '5 - Modest – stable basics, small markets, slow growth',
  '6 - Comfortable – steady work, functioning towns, good stores',
  '7 - Prosperous – strong trade, skilled labor, thriving farms/mines',
  '8 - Wealthy – luxury goods, powerful merchant families, expansion',
  '9 - Booming – major production hub, high migration, big projects',
  '10 - Golden Province – legendary riches, envy, heavy competition',
];
